export const DEFAULT_TRANSIT_COLOR = '#9A66DD';

export type TransitMapTheme = Record<string, { fillColor?: unknown }>;

export const getTransitColors = (mapTheme: TransitMapTheme = {}) => {
  const color = (category: string) => {
    const { fillColor } = {
      ...mapTheme.default,
      ...mapTheme.selected,
      ...mapTheme.desaturation,
      ...mapTheme[category],
    };
    return typeof fillColor === 'string' && fillColor.trim() ? fillColor : DEFAULT_TRANSIT_COLOR;
  };
  return { train: color('nav.train'), bus: color('nav.transit') };
};
